import { type z } from 'zod';

import {
  type ClassificacaoPersonalizada,
  type classificacaoPersonalizadaEntradaSchema,
} from '@fiscoai/contracts';

import { EXEMPLO } from './textos';

/** Valores do formulário (entrada do schema: `ativa` e `patrimonio` podem faltar até validar). */
export type FormClassificacao = z.input<typeof classificacaoPersonalizadaEntradaSchema>;

/** O que o editor recebe ao abrir. */
export interface RascunhoClassificacao {
  /** Nulo: classificação nova. */
  id: string | null;
  valores: FormClassificacao;
}

export function rascunhoNovo(): RascunhoClassificacao {
  return {
    id: null,
    valores: {
      nome: '',
      ativa: true,
      cfopEntrada: { tipo: 'FINAL', final: '', cfopsFornecedor: [] },
      grupo: 'CUSTO',
      patrimonio: false,
    },
  };
}

/** O exemplo do estado vazio, já preenchido: a pessoa ajusta o nome e salva. */
export function rascunhoDoExemplo(): RascunhoClassificacao {
  return {
    id: null,
    valores: {
      nome: EXEMPLO.nome,
      ativa: true,
      cfopEntrada: {
        tipo: 'FINAL',
        final: EXEMPLO.final,
        cfopsFornecedor: [...EXEMPLO.cfopsFornecedor],
      },
      grupo: 'CUSTO',
      patrimonio: false,
    },
  };
}

export function rascunhoDaClassificacao(c: ClassificacaoPersonalizada): RascunhoClassificacao {
  return {
    id: c.id,
    valores: {
      nome: c.nome,
      ativa: c.ativa,
      cfopEntrada: c.cfopEntrada,
      grupo: c.grupo,
      patrimonio: c.patrimonio,
    },
  };
}
